export const MOBILE_PAY_ACCOUNT_NUMBER = 5802
export const MOBILE_PAY_ACCOUNT_NAME = 'MobilePay'
